export function formatMessageTime(timestamp) {
  if (!timestamp) return ''

  const date = new Date(timestamp)
  const now = new Date()
  const diffInSeconds = Math.floor((now - date) / 1000)
  const diffInMinutes = Math.floor(diffInSeconds / 60)
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)

  if (diffInMinutes < 1) {
    return 'Just now'
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`
  } else if (diffInHours < 24) {
    return `${diffInHours}h ago`
  } else if (diffInDays === 1) {
    return 'Yesterday'
  } else if (diffInDays < 7) {
    return `${diffInDays}d ago`
  } else {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
}

export function formatTimestamp(timestamp) {
  if (!timestamp) return ''

  const date = new Date(timestamp)
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })
}

export function groupMessagesBySender(messages) {
  if (!messages || messages.length === 0) return []

  const groups = []
  let currentGroup = null

  messages.forEach((message) => {
    if (!currentGroup || currentGroup.senderId !== message.sender?.id) {
      currentGroup = {
        senderId: message.sender?.id,
        senderName: message.sender?.preferredName || message.sender?.fullName,
        senderAvatar: message.sender?.cloudinaryPhotoPublicId,
        messages: []
      }
      groups.push(currentGroup)
    }
    currentGroup.messages.push(message)
  })

  return groups
}

export function getDraftKey(conversationId) {
  return `message_draft_${conversationId}`
}

export function saveDraft(conversationId, content) {
  try {
    localStorage.setItem(getDraftKey(conversationId), content)
  } catch (error) {
    console.error('Error saving draft:', error)
  }
}

export function loadDraft(conversationId) {
  try {
    return localStorage.getItem(getDraftKey(conversationId)) || ''
  } catch (error) {
    console.error('Error loading draft:', error)
    return ''
  }
}

export function clearDraft(conversationId) {
  try {
    localStorage.removeItem(getDraftKey(conversationId))
  } catch (error) {
    console.error('Error clearing draft:', error)
  }
}
